import './materialButton.scss';
export const MaterialButtonComponent = {
    controllerAs: '$ctrl',
    transclude: true,
    bindings: {
        iconName: '@',
        disabled: '<?',
    },
    template: `
    <div class="material-button">
        <button ng-disabled="$ctrl.disabled">
            <i class="material-icons icon">{{$ctrl.iconName}}</i>
        </button>
    </div>`,
};
